import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

interface Disposition {
  businessDispositionId: number;
  disposition: string;
}

interface AIOOutcomeCallOutcomeProps {
  selectedDispositionId: string;
  handleCallOutcomeChange: (event: SelectChangeEvent<string>) => void;
  dispositions: Disposition[];
}

export const AIOOutcomeCallOutcome = ({
  selectedDispositionId,
  handleCallOutcomeChange,
  dispositions,
}: AIOOutcomeCallOutcomeProps) => {
  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <FormControl fullWidth required>
        <InputLabel
          sx={{
            fontFamily: 'DM Sans',
            fontWeight: 500,
            fontSize: 18,
            color: 'black',
            mb: 1,
            position: 'static',
            transform: 'none',
            '&.Mui-focused': {
              color: 'black',
            },
          }}
        >
          Call Outcome
        </InputLabel>
        <Select
          value={selectedDispositionId}
          onChange={handleCallOutcomeChange}
          displayEmpty
          sx={{
            mt: 1,
            borderRadius: '10px !important',
            '& .MuiInputBase-root': {
              borderRadius: '10px !important',
              fontFamily: 'DM Sans',
              fontWeight: 600,
              fontSize: 16,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'black !important',
              borderWidth: '1px !important',
              borderRadius: '10px !important',
            },
            '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'black !important',
              borderWidth: '1px !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'black !important',
              borderWidth: '2px !important',
            },
            '& .MuiSelect-select': {
              py: 1.75,
              color: selectedDispositionId ? 'black' : '#8E8E8E',
            },
          }}
        >
          <MenuItem value="" disabled sx={{ color: '#8E8E8E' }}>
            Select one
          </MenuItem>
          {dispositions.map((disposition: Disposition) => (
            <MenuItem
              key={disposition.businessDispositionId}
              value={disposition.businessDispositionId.toString()}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: '#F5F5F5',
                  '&:hover': {
                    backgroundColor: '#F5F5F5',
                  },
                },
                '&:hover': {
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              {disposition.disposition}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
